import { render, staticRenderFns } from "./export-tip.vue?vue&type=template&id=0e1e517d&"
import script from "./export-tip.vue?vue&type=script&lang=js&"
export * from "./export-tip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports